import { createStore, compose, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise';
import { defaultStorageResolver } from '../common/utils/resolvers';
import rootReducer from '../reducers';
import persistentStateMiddleware from './persistentStateMiddleware';
import persistentStateExtension from './persistentStateExtension';

const storageResolver = defaultStorageResolver({
  storageKey: 'engage-settings',
});

const middlewares = [
  persistentStateMiddleware({ storageResolver, properties: ['currentUser'] }),
  thunkMiddleware,
  promiseMiddleware,
];

export default function configureStore(initialState) {
  const win = typeof window !== 'undefined' ? window : {};
  const store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(...middlewares),
      persistentStateExtension({ storageResolver }),
      win.devToolsExtension ? win.devToolsExtension() : f => f
    )
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers').default;

      store.replaceReducer(nextReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js